import { TypographyVariantsOptions } from '@mui/material/styles';
declare module '@mui/material/styles' {
  interface TypographyVariants {
    inputLabel: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    inputLabel?: React.CSSProperties;
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    inputLabel: true;
  }
}
export const typography: TypographyVariantsOptions = {
  fontFamily: '"Nunito Sans", sans-serif',
  fontWeightMedium: 600,
  button: {
    fontFamily: '"Nunito Sans", Roboto, Arial, sans-serif',
    fontWeight: 700,
    fontSize: '14px',
    textTransform: 'none',
    letterSpacing: '-1px',
  },
  body2: {
    fontSize: '12px',
  },
  body1: {
    fontSize: '14px',
  },
  h6: {
    fontSize: '16px',
  },
  h5: {
    fontSize: '18px',
  },
  h4: {
    fontSize: '20px',
  },
  h3: {
    fontSize: '22px',
  },
  h2: {
    fontSize: '24px',
  },
  caption: {
    fontSize: '10px',
  },
  inputLabel: {
    fontFamily: '"Nunito Sans", sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 1.5,
    marginBottom: '8px',
  },
};
